import { Skeleton } from 'front-commons/ds';
import { memo } from 'react';

function DistributorCardSkeleton() {
	return <Skeleton height="72px" width="100%" />;
}

export default memo(DistributorCardSkeleton);
